module.exports = __webpack_public_path__ + "static/media/header-strand.92e53652.png";